import { SaveDialogContent, SaveButton } from "@/components/SaveForm";
import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LocationMap } from "@/components/LocationMap";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Skeleton } from "@/components/ui/skeleton";
import { Dialog, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { MapPin, Plus } from "lucide-react";

const inp = "bg-slate-950 border-slate-700 text-slate-100 mt-1";

export default function Locations() {
  const { can } = useAuth();
  const [list, setList] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({});

  const load = () => api.get("/locations").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.almoxarifado) { toast.error("Informe ao menos o almoxarifado."); return; }
    try { await api.post("/locations", form); toast.success("Localização cadastrada."); setOpen(false); setForm({}); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  if (list === null) return <Skeleton className="h-96 bg-slate-800" />;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-3">
        <div><h1 className="font-display text-3xl font-bold text-slate-50">Localizações</h1><p className="text-slate-400 text-sm">Estrutura Almoxarifado → Corredor → Estante → Prateleira → Caixa.</p></div>
        {can("ALMOXARIFADO") && <Button data-testid="btn-new-location" onClick={() => setOpen(true)} className="bg-sky-700 hover:bg-sky-600"><Plus className="h-4 w-4 mr-1" /> Nova localização</Button>}
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        {list.map((l) => (
          <Card key={l.id} className="card-metal p-5"><LocationMap location={l} /></Card>
        ))}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <SaveDialogContent className="bg-slate-900 border-slate-700 text-slate-100">
          <DialogHeader><DialogTitle className="font-display text-2xl">Nova localização</DialogTitle></DialogHeader>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Almoxarifado *</Label><Input className={inp} placeholder="Almoxarifado A" onChange={(e) => setForm({ ...form, almoxarifado: e.target.value })} /></div>
            <div><Label>Corredor</Label><Input className={inp} placeholder="Corredor 1" onChange={(e) => setForm({ ...form, corredor: e.target.value })} /></div>
            <div><Label>Estante</Label><Input className={inp} placeholder="Estante 03" onChange={(e) => setForm({ ...form, estante: e.target.value })} /></div>
            <div><Label>Prateleira</Label><Input className={inp} placeholder="Prateleira B" onChange={(e) => setForm({ ...form, prateleira: e.target.value })} /></div>
            <div><Label>Caixa/Posição</Label><Input className={inp} placeholder="Caixa 12" onChange={(e) => setForm({ ...form, caixa: e.target.value })} /></div>
          </div>
          <DialogFooter><Button variant="ghost" onClick={() => setOpen(false)}>Cancelar</Button><SaveButton onClick={save} className="bg-sky-700 hover:bg-sky-600">Salvar</SaveButton></DialogFooter>
        </SaveDialogContent>
      </Dialog>
    </div>
  );
}
